import React from 'react';
import _ from 'lodash';
import cx from 'classnames';
import { dayjs } from '../utils/time';

import { EmptyItem } from 'components/EmptyItem';


// ====================
// ITEM
// ====================
export const ThumbItem = ({ thumb, size, onClick, ...props }) => {
  
  let sinceStart = dayjs.duration(thumb.sinceStart).format("HH:mm:ss");
  const onThumbClick = () => onClick?.(thumb);
  return (
    <div className={cx("g-thumb-item")} onClick={onThumbClick}>
      <img src={thumb.imageUrl} />
      <div className="thumb-since">{sinceStart}</div>
    </div>
  );
}
export default ThumbItem;


// ====================
// LIST
// ====================
export const ThumbList = ({ liveThumbs, loading, loadingCount = 4, className, size, align, ...props }) => {
  if(!loading && _.isEmpty(liveThumbs)) 
  return (
    <EmptyItem>
      <p>There were no live thumbs available prior to Q1 2024</p>
    </EmptyItem>);

  return (
    <div className={cx("g-thumb-list", className, size, align)}>
      <div className="list-wrapper">
        { liveThumbs && _.map(liveThumbs, (thumb, idx) => {
          return (
            <ThumbItem
              key={idx}
              thumb={thumb}
              {...props} />);
        })}
      </div>
    </div>)
}
  